import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type State = boolean;

const initialState: State = false;

const patientLabsSlice = createSlice({
  name: 'patientLabs',
  initialState,
  reducers: {
    setShowOrders(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setShowOrders } = patientLabsSlice.actions;

export default patientLabsSlice.reducer;
